import './KpiMeta.scss';
import { ReactNode } from 'react';

type Tone = 'positive' | 'negative' | 'neutral';
type DeltaKind = 'percent' | 'number';

type KpiMetaProps = {
  tone?: Tone;
  children: ReactNode;
}

export const KpiMeta = ({ tone = 'neutral', children }: KpiMetaProps) => (
  <span className={`kpi-meta-content ${tone}`}>{children}</span>
);

type KpiDeltaProps = {
  value: number;
  kind?: DeltaKind;
  suffix?: string;
  tone?: Tone;
  showArrow?: boolean;
  digits?: number;
}

export const KpiDelta = ({ value, kind = 'percent', suffix, tone, showArrow = true, digits = kind === 'percent' ? 1 : 0 }: KpiDeltaProps) => {
  const direction = Math.sign(value);
  const resolvedTone = tone ?? (direction === 0 ? 'neutral' : direction > 0 ? 'positive' : 'negative');
  const sign = direction > 0 ? '+' : direction < 0 ? '-' : '';
  const formattedValue =
    kind === 'percent'
      ? `${sign}${Math.abs(value).toFixed(digits)}%`
      : `${sign}${Math.abs(value).toLocaleString()}`;

  return (
    <KpiMeta tone={resolvedTone}>
      {showArrow && direction !== 0 && <span className='kpi-meta-arrow'>{direction > 0 ? '▲' : '▼'}</span>}
      {formattedValue}
      {suffix && <span className='kpi-meta-suffix'>{suffix}</span>}
    </KpiMeta>
  );
};
